import * as _ from 'underscore';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { IUserNotification } from '../../models/IUserNotification';
import { GetUserNotifications, UpdateUserNotificationsStatus, DeleteUserNotifications, CheckHasUnseenUserNotifications, UpdateLastSeenUserNotification } from '../../../app/actions/AppActionTypes';
import { GetUserNotificationsAction, getUserNotificationsSucceededAction, getUserNotificationsFailedAction } from '../actions/GetUserNotificationsAction';
import { UpdateUserNotificationsStatusAction, updateUserNotificationsStatusSucceededAction } from '../actions/UpdateUserNotificationStatusAction';
import { requestFailed } from '../../../app/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { DeleteUserNotificationsAction, deleteUserNotificationsSucceededAction } from '../actions/DeleteUserNotification';
import { CheckHasUnseenUserNotificationsAction, checkHasUnseenUserNotificationsSucceededAction } from '../actions/CheckHasUnseenUserNotificationsAction';
import { UserNotificationsResources } from '../../resources/UserNotificationsResource';
import { updateLastSeenUserNotificationAction, updateLastSeenUserNotificationSucceededAction, UpdateLastSeenUserNotificationAction } from '../actions/UpdateLastSeenUserNotificationAction';

export function* handleGetUserNotificationRequest(action: GetUserNotificationsAction) {
    try {
        const notifications: _.Dictionary<IUserNotification> = yield call(getUserNotificationsRequest);
        yield put(getUserNotificationsSucceededAction(notifications));

        // TODO (zszugyi): will put this logic here, there is probably a better place
        if (!_.isEmpty(notifications)) {
          const lastSeenId = _.max(_.values(notifications), n => n.creationTime).id;
          yield put(updateLastSeenUserNotificationAction(lastSeenId));
        }
    } catch (e) {
        //TODO handle fetch failure
        yield put(getUserNotificationsFailedAction());
    }
}

export function* handleUpdateUserNotificationsStatusRequest(action: UpdateUserNotificationsStatusAction) {
    try {
        const updateSucceed: boolean = yield call(updateUserNotificationsStatusRequest, action.notificationIds, action.isRead);
        if (updateSucceed) {
            yield put(updateUserNotificationsStatusSucceededAction(action.notificationIds, action.isRead));
        } else {
            yield put(requestFailed('update failure', Messages.errorUnknown()));
        }
    } catch (e) {
        //TODO handle fetch failure
        //yield put(requestFailed(e, Messages.errorUnknown()));
    }
}

export function* handleDeleteUserNotificationsRequest(action: DeleteUserNotificationsAction) {
    try {
        const updateSucceed: boolean = yield call(deleteUserNotificationsRequest, action.notificationIds);
        if (updateSucceed) {
            yield put(deleteUserNotificationsSucceededAction(action.notificationIds));
        } else {
            yield put(requestFailed('delete failure', Messages.errorUnknown()));
        }
    } catch (e) {
        //TODO handle fetch failure
        //yield put(requestFailed(e, Messages.errorUnknown()));
    }
}

export function* handleCheckHasUnseenUserNotificationsRequest(action: CheckHasUnseenUserNotificationsAction) {
  try {
    const hasUnseen: boolean = yield call(checkHasUnseenUserNotificationsRequest);
    yield put(checkHasUnseenUserNotificationsSucceededAction(hasUnseen));
  } catch (e) {
    // TODO: handle fetch failure if we care. TODO: can we log the error on the console?
  }
}

export function* handleUpdateLastSeenUserNotificationRequest(action: UpdateLastSeenUserNotificationAction) {
  try {
    yield call(updateLastSeenUserNotificationRequest, action.lastSeenUserNotificationId); // TODO: finalize param
    yield put(updateLastSeenUserNotificationSucceededAction());
  } catch (ignored) {
  }
}

export function getUserNotificationsRequest(): Promise<_.Dictionary<IUserNotification>> {
    return Promise.resolve(UserNotificationsResources.getAllUserNotifications());
}

export function updateUserNotificationsStatusRequest(ids: string[], isRead: boolean): Promise<boolean> {
    return UserNotificationsResources.updateNotificationsStatus(ids, isRead);
}

export function deleteUserNotificationsRequest(ids: string[]): Promise<boolean> {
    return UserNotificationsResources.deleteNotifications(ids);
}

export function checkHasUnseenUserNotificationsRequest(): Promise<boolean> {
  return UserNotificationsResources.checkHasUnseenUserNotifications();
}

export function updateLastSeenUserNotificationRequest(id: string) {
  return UserNotificationsResources.updateLastSeenUserNotification(id);
}

export function* rootUserNotificationSagas(): SagaIterator {
    yield takeLatest(GetUserNotifications, handleGetUserNotificationRequest);
    yield takeEvery(UpdateUserNotificationsStatus, handleUpdateUserNotificationsStatusRequest);
    yield takeEvery(DeleteUserNotifications, handleDeleteUserNotificationsRequest);
    yield takeLatest(CheckHasUnseenUserNotifications, handleCheckHasUnseenUserNotificationsRequest);
    yield takeLatest(UpdateLastSeenUserNotification, handleUpdateLastSeenUserNotificationRequest);
}